import React from 'react';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  draft: { label: 'Draft', color: 'default' },
  submitted: { label: 'Submitted', color: 'info' },
  under_review: { label: 'Under Review', color: 'warning' },
  approved: { label: 'Approved', color: 'success' },
  rejected: { label: 'Rejected', color: 'error' },
  paid: { label: 'Paid', color: 'success' },
  cancelled: { label: 'Cancelled', color: 'default' }
};

export default function ClaimStatusBadge({ status, size = 'small' }) {
  const config = STATUS_CONFIG[status] || { label: status || '—', color: 'default' };
  return <Chip label={config.label} color={config.color} size={size} variant="outlined" />;
}
